export const APP_SOURCE_CHAT_PROFILE = 'chat_profile';
export const APP_SOURCE_DEEPLINK = 'deeplink';
export const APP_SOURCE_EDIT_PROFILE = 'editprofile';
export const APP_SOURCE_HOME_PROFILE_TAB = 'home_profile_tab';
export const APP_SOURCE_ONBOARDING = 'onboarding';
export const APP_SOURCE_RECS = 'recs';
export const APP_SOURCE_RECS_PROFILE = 'recs_profile';
export const APP_SOURCE_RECS_TAPPY = 'recs_tappy';
export const APP_SOURCE_SETTINGS = 'settings';
